import {Invoke} from "../../react/invoke";

export const BlockSelectingReadonlyText = ({onSelect, ccEditor}) => Invoke({
    props: onSelect,
    action: ({getLatestProps}) => {
        const CustomersCanvas = window["CustomersCanvas"] || null;
        ccEditor.subscribe(
            CustomersCanvas.IframeApi.PostMessage.Events.BoundsNotification,
            async (args) => {
                const onSelect = getLatestProps();

                const product = await ccEditor.getProduct();
                const productModel = await product.getProductModel();
                const allItems = await productModel.getAllItems();
                const surface = product.currentSurface;
                const item = allItems.find( (item) => {
                    return (
                        item.name !== "" &&
                        item.name === args.selectedGroup.items[0] &&
                        item.type === "BoundedTextItem" &&
                        item.textPermissions.allowChangeText === false &&
                        surface.name === item.parentContainer.parentComponent.name &&
                        true
                    );
                });

                if (item) {
                    onSelect(item);
                    ccEditor.clearSelection();
                }

                ccEditor.removeEditorSelectImageButtonPositionData();
            },
        );
    },
});
